import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, ArrowUpRight } from "lucide-react";

/** Tarjeta KPI unificada (Finanzas). Un solo acento por estado: ícono + valor; el fondo siempre neutro. */
export const KPI_TONES = {
  primary: { icon: "text-primary", value: "text-primary", ring: "border-primary/40" },
  emerald: { icon: "text-emerald-600", value: "text-emerald-700", ring: "border-emerald-500/40" },
  amber: { icon: "text-amber-600", value: "text-amber-700", ring: "border-amber-500/40" },
  rose: { icon: "text-rose-600", value: "text-rose-700", ring: "border-rose-500/40" },
  blue: { icon: "text-blue-600", value: "text-blue-700", ring: "border-blue-500/40" },
  slate: { icon: "text-muted-foreground", value: "text-foreground", ring: "border-border" },
  muted: { icon: "text-muted-foreground", value: "text-foreground", ring: "border-border" },
};

export default function KpiCard({ icon: Icon, label, value, sub, tone = "muted", testid, action, tooltip, nota, destacado = false, className = "", to, onClick }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const t = KPI_TONES[tone] || KPI_TONES.muted;
  const ir = onClick || (to ? () => navigate(to) : null);
  return (
    <div
      role={ir ? "link" : undefined}
      tabIndex={ir ? 0 : undefined}
      onClick={ir ? (e) => { if (e.target.closest("button,a,input")) return; ir(); } : undefined}
      onKeyDown={ir ? (e) => { if (e.key === "Enter") ir(); } : undefined}
      className={`relative rounded-xl border bg-card p-4 ${destacado ? `border-2 ${t.ring}` : "border-border"} ${ir ? "cursor-pointer hover:border-primary/50 hover:shadow-sm transition-[border-color,box-shadow]" : ""} ${className}`}
      data-testid={testid} title={tooltip || (ir ? "Ver detalle" : undefined)}>
      {ir && !action && <ArrowUpRight className="absolute top-2 right-2 w-3.5 h-3.5 text-muted-foreground/50" />}
      <div className="flex items-center justify-between gap-1">
        <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-muted-foreground min-w-0">
          {Icon && <Icon className={`w-3.5 h-3.5 flex-shrink-0 ${t.icon}`} />} <span className="truncate">{label}</span>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          {nota && (
            <button type="button" onClick={() => setOpen((o) => !o)} className={`rounded-full p-0.5 transition-colors ${open ? "text-primary" : "text-muted-foreground hover:text-primary"}`} title="¿Qué cuenta este número?" data-testid={testid ? `${testid}-nota-btn` : undefined}>
              <HelpCircle className="w-3.5 h-3.5" />
            </button>
          )}
          {action}
        </div>
      </div>
      <div className={`text-2xl font-display font-bold tabular-nums mt-1 ${t.value}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-0.5">{sub}</div>}
      {nota && open && <div className="text-[11px] text-foreground/80 mt-2 pt-2 border-t border-border/60 leading-relaxed" data-testid={testid ? `${testid}-nota` : undefined}>{nota}</div>}
    </div>
  );
}
